import styles from "./contactcard.module.css";
import { Dropdown } from "react-bootstrap";
import { MoreVertical, Trash2 } from "react-feather";
import { useHistory } from "react-router-dom";

const ContactCard = ({ item, setDeleteModalOpen, setSelectecId, groupDetails }) => {
    const navigate = useHistory();

    const clickCard = () => {
        if (groupDetails?.type === 'Prospect') {
            navigate.push(`/people/prospects/details/${item.prospect_id}`)
        }
        if (groupDetails?.type === 'Tenant') {
            navigate.push(`/people/tenants/details/${item.tenant_root_id}`)
        }

        if (groupDetails?.type === 'Contact') {
            navigate.push(`/people/contacts`)
        }
    }

    return (<>
        {/* <div className={`${styles.ProspectCard}`} style={{ cursor: 'pointer' }} onClick={(e) => clickCard()}>
            <div className={`${styles.ProspectCardUnder}`}>
                <div className={`${styles.ProspectCardHeadSection}`}>
                    <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                            <MoreVertical />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={`${styles.ActionsBUList}`}>
                            <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectecId(item.id); }}>
                                <Trash2 /> Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    <div className={`${styles.ProsIMGSec}`}>
                        <p>{item?.initial}</p>
                        <img src="/static/img/contact-list.svg" alt="" className={`${styles.Icon}`} />
                    </div>
                    <div className={`${styles.HeadConSec}`}>
                        <p className={`${styles.ProsUserName}`}>
                            <span className={`${styles.UserName}`}>{item?.name}</span>
                        </p>
                        <p className={`${styles.ProsUserName} ${styles.Small}`}>{groupDetails?.title}</p>
                    </div>
                </div>
                <div className={`${styles.ProspectCardBodySec}`}>
                    <ul>
                        <li>
                            <p className={`${styles.Title}`}>Email:</p>
                            <p className={`${styles.Content}`}>{item?.email}</p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>Phone:</p>
                            <p className={`${styles.Content}`}>{item?.phone !== '' ? item?.phone : '-'}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div> */}
        <div className={`${styles.ListingCard}`} style={{ cursor: 'pointer' }} onClick={(e) => clickCard()}>
            <div className={`${styles.ListingImg}`}><img src="/static/img/contact-list.svg" alt="" /></div>
                <div className={`${styles.ListingDesSec}`}>
                <div className={`${styles.TitleRow}`}>
                    <span className={`${styles.Title}`}>{item?.name}</span>
                </div>
                <p className={`${styles.ListingDesSmallSec}`}>{item?.phone !== '' ? item?.phone : '-'} <span>{item?.email}</span></p>
            </div>
            <div className={`${styles.ActionRight}`}>                              
                <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList}`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectecId(item.id); }}>
                            <Trash2 /> Delete
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    </>);
}

export default ContactCard;